import React, { useEffect } from 'react';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { useForm, useFieldArray } from 'react-hook-form';
import NumberForm from './NumberForm';

export default function NumberFormContainer({ id, submit, intialValue, extraTnOptions, isCnam, setIsCnam }) {
  const form = useForm({ defaultValues: intialValue });
  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors, submitCount, isSubmitted },
  } = form;

  const number = useFieldArray({ control, name: 'tnItem' });

  useEffect(() => {
    if (isSubmitted && Object.keys(errors).length) {
      console.log(errors, getValues());
      toast.error('Please fix error and submit again');
    }
  }, [submitCount]);

  return (<>
    <div className="p font-weight-bold w-100 pt-3 text-primary">
      Would you like to add features to this order? (Features will be added in next page)
    </div>
    <Row style={{ marginLeft: 10 }}>
      <Col md={1}>
        <Label>
          <Input
            onChange={e => setIsCnam('no')}
            checked={isCnam === 'no'}
            type="checkbox"
          />{' '}
          No
        </Label>
      </Col>
      <Col md={4}>
        <Label>
          <Input
            type="checkbox"
            onChange={e => setIsCnam('yes')}
            checked={isCnam === 'yes'}
          />{' '}
          Yes
        </Label>
      </Col>
    </Row>
    <form onSubmit={handleSubmit(submit)} className="shadow-none row no-gutters">
      {number.fields.map((item, index) => (
        <div key={item.id}>
          <NumberForm
            id={id}
            extraTnOptions={extraTnOptions}
            form={form}
            index={index}
            fields={item}
          />

          {number.fields.length > 1 && !id && (
            <Button type="button" className="ml-3 mr-2 mt-3" onClick={() => number.remove(index)}>
              Delete Number Form
            </Button>
          )}

          <hr />
        </div>
      ))}
      <div className="d-flex justify-content-between col-12 align-items-end">
        <div>
          {number.fields.length < 5 && !id && (
            <>
              <small className="d-block mb-1">
                Add Different End User Information ? (You can use this button 4 times)
              </small>
              <Button onClick={() => number.append({})} type="button" className="align-self-bottom">
                Add Another Number Form
              </Button>
            </>
          )}
        </div>
        <button type="submit" className="btn btn-primary mr-2">
          Next
        </button>
      </div>
    </form></>
  );
}
